import { createContext, useContext, useState, ReactNode } from 'react'
import { LANGUAGES, LanguageCode, DEFAULT_LANGUAGE } from '../config/languages'

interface LanguageContextType {
    language: LanguageCode
    setLanguage: (lang: LanguageCode) => void
    languageInfo: typeof LANGUAGES[LanguageCode]
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined)

export function LanguageProvider({ children }: { children: ReactNode }) {
    const [language, setLanguageState] = useState<LanguageCode>(() => {
        const saved = localStorage.getItem('mavililer_language')
        return (saved && saved in LANGUAGES) ? saved as LanguageCode : DEFAULT_LANGUAGE
    })

    const setLanguage = (lang: LanguageCode) => {
        setLanguageState(lang)
        localStorage.setItem('mavililer_language', lang)
    }

    const languageInfo = LANGUAGES[language]

    return (
        <LanguageContext.Provider value={{ language, setLanguage, languageInfo }}>
            {children}
        </LanguageContext.Provider>
    )
}

export function useLanguage() {
    const context = useContext(LanguageContext)
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider')
    }
    return context
}
